module.exports = __webpack_public_path__ + "img/W.b246863b.gif";